module.exports = __webpack_public_path__ + "img/stock0.c4f9cfdf.png";